import apiSlice from "./ApiSlice";

const modeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllModeData: builder.query({
      providesTags: ["mode"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/mode",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteModeById: builder.mutation({
      invalidatesTags: ["mode"],
      query: (id: any) => ({
        url: `/mode/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addMode: builder.mutation({
      invalidatesTags: ["mode"],
      query: (body) => ({
        url: `/mode/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getModeById: builder.query({
      providesTags: ["mode"],
      query: (id: string) => {
        return {
          url: `/mode/${id}`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateModeById: builder.mutation({
      invalidatesTags: ["mode"],
      query: ({ body, id }) => ({
        url: `/mode/${id}`,
        method: "PUT",
        body,
      }),
    }),


    //get all modes
    getAllModes: builder.query({
      providesTags: ["mode"],
      query: () => {
        return {
          url: `/mode`,
          method: "GET",
        };
      },
    }),


    // change status of delivery date
    changeStatusModeById: builder.mutation({
      invalidatesTags: ["mode"],
      query: ({ body, id }) => ({
        url: `/mode/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllModeDataQuery,
  useDeleteModeByIdMutation,
  useAddModeMutation,
  useGetModeByIdQuery,
  useUpdateModeByIdMutation,
  useGetAllModesQuery,
  useChangeStatusModeByIdMutation,
} = modeApi;
